export const GuardianLogoIcon = () => (
  <>
    <g id="GUARDIAN_LOGO 1" clipPath="url(#clip0_9789_20306)">
      <path
        id="Vector"
        d="M39.7809 7.62497L39.2306 12.3814C38.2939 13.1418 36.7774 13.6637 35.2757 13.6637C32.8375 13.6637 30.9492 12.2323 30.9492 9.23527C30.9492 5.68659 33.1943 2.79395 36.5098 2.79395C37.9817 2.79395 39.3644 3.45001 40.1227 4.71742L38.2939 6.11898C37.8925 5.52257 37.2532 5.04542 36.376 5.04542C34.6067 5.04542 33.4619 6.99871 33.4619 9.10111C33.4619 10.6518 34.2053 11.457 35.4393 11.457C35.9894 11.457 36.4949 11.3228 37.0748 10.95L37.268 9.62294H35.5136L35.7664 7.62497H39.7809Z"
        fill="#8F918D"
      />
      <path
        id="Vector_2"
        d="M49.1595 9.16105C48.7578 12.4414 47.2564 13.664 44.6692 13.664C42.246 13.664 41.1754 12.2326 41.1754 9.90657C41.1754 9.54871 41.2049 9.17595 41.2496 8.80319L41.9784 2.94336H44.3422L43.6286 8.78828C43.5986 9.10142 43.5691 9.3996 43.5691 9.66801C43.5691 10.7117 43.911 11.4274 44.8475 11.4274C45.9181 11.4274 46.5723 10.8608 46.7805 9.10142L47.5388 2.94336H49.9177L49.1595 9.16105Z"
        fill="#8F918D"
      />
      <path
        id="Vector_3"
        d="M55.8375 13.5298L55.5252 11.5765H52.3732L51.5854 13.5298H49.0876L53.8451 2.94336H56.1347L58.3054 13.5298H55.8375ZM53.1909 9.54871H55.1981L54.6481 6.02985H54.6181L53.1909 9.54871Z"
        fill="#8F918D"
      />
      <path
        id="Vector_4"
        d="M65.2764 9.6382V9.6531L67.0458 13.5298H64.3992L62.9421 10.0706H62.1244L61.708 13.5298H59.3741L60.6673 2.94336H64.4287C66.54 2.94336 67.4172 4.16604 67.4172 5.86583C67.4172 7.62528 66.6593 8.98212 65.2764 9.6382ZM62.7339 5.04573L62.3773 7.96819H63.3139C64.3099 7.96819 64.9345 7.19285 64.9345 6.1342C64.9345 5.37377 64.4287 5.04573 63.8344 5.04573H62.7339Z"
        fill="#8F918D"
      />
      <path
        id="Vector_5"
        d="M71.5159 13.5298H68.2598L69.5533 2.94336H72.8836C75.7979 2.94336 77.2398 4.65806 77.2398 7.34196C77.2398 11.0099 75.099 13.5298 71.5159 13.5298ZM71.7983 11.3976C73.7608 11.3976 74.7719 9.60834 74.7719 7.38668C74.7719 5.92546 74.1026 5.07558 72.616 5.07558H71.62L70.8465 11.3976H71.7983Z"
        fill="#8F918D"
      />
      <path
        id="Vector_6"
        d="M80.5868 13.5298H78.1783L79.4568 2.94336H81.8804L80.5868 13.5298Z"
        fill="#8F918D"
      />
      <path
        id="Vector_7"
        d="M88.4333 13.5298L88.121 11.5765H84.969L84.1812 13.5298H81.6834L86.4409 2.94336H88.7305L90.9012 13.5298H88.4333ZM85.7867 9.54871H87.7939L87.2438 6.02985H87.2143L85.7867 9.54871Z"
        fill="#8F918D"
      />
      <path
        id="Vector_8"
        d="M99.121 2.94336H101.5L100.192 13.5298H97.7385L95.1218 7.26743H95.1067L94.3336 13.5298H91.9698L93.263 2.94336H95.642L98.3033 9.36979H98.3332L99.121 2.94336Z"
        fill="#8F918D"
      />
      <path
        id="Vector_9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3921 0C17.3707 0 17.3512 0.0109003 17.3411 0.0290273C16.0258 2.38117 14.1291 5.77202 12.6984 8.3264H9.43481C9.39293 8.3264 9.35428 8.34794 9.33358 8.38287L7.96106 10.6983C7.939 10.7355 7.96705 10.7817 8.01168 10.7817H11.3021C10.9414 11.3739 10.5751 11.9037 10.1661 12.3372C9.42518 13.1225 8.37408 13.5938 6.90791 13.4502C4.7965 13.2436 3.45579 11.3147 3.45579 9.17577C3.45579 7.87161 4.45279 5.93842 5.60256 5.14252C6.95701 4.20488 8.80694 3.94661 10.8942 5.1337C10.9496 5.16519 11.0219 5.14911 11.0556 5.09651L12.3098 3.133C12.3411 3.084 12.3281 3.01981 12.2797 2.98591C9.56316 1.08251 6.13044 1.57722 3.95996 3.05659C1.87135 4.48016 0.656578 6.49159 0.511901 9.08898C0.306768 12.7716 2.76806 15.6373 6.77327 15.9732C9.13274 16.1711 10.9484 15.2491 12.2133 14.0088C13.1873 13.0538 13.7269 12.0729 14.2661 11.0928L14.2664 11.0922C14.5475 10.5812 15.4505 9.07317 15.4505 9.07317L14.9889 10.6397C14.9679 10.7109 15.0238 10.7817 15.1009 10.7817H19.7717L20.2589 12.6387C20.2654 12.6635 20.2887 12.6809 20.3154 12.6809H22.9501C22.9882 12.6809 23.016 12.6465 23.0065 12.6112L19.6357 0.0419091C19.6291 0.0172433 19.6059 0 19.5794 0H17.3921ZM19.1276 8.3264L18.0622 4.26583C18.0622 4.26583 17.0087 6.16242 15.9424 8.07941L15.847 8.24343C15.8254 8.28062 15.8534 8.3264 15.8979 8.3264H19.1276Z"
        fill="#8F918D"
      />
    </g>
    <defs>
      <clipPath id="clip0_9789_20306">
        <rect width="101" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </>
);
